import { render, staticRenderFns } from "./EmployeeBadge.vue?vue&type=template&id=60b71ddc&"
import script from "./EmployeeBadge.vue?vue&type=script&lang=js&"
export * from "./EmployeeBadge.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBadge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports